import { ContentService, DavisAlertService } from "@DavisDigital/davisdigitalfrontend.module";
import { AccessAccount} from "@DavisDigital/interfaces";


class AgreementPrivacyModalController {
    
    private close:Function; //injected from modal-service
    private slatwall: any;
    
    public loading: boolean = true;
    public modalContent: string = null;
    public agreeChecked: boolean = false;
    public sending: boolean = false;
	
	// @ngInject
	constructor(
		public contentService     : ContentService,
		private davisAlertService : DavisAlertService
	){}
	
	public $onInit = () => {
        this.contentService.getCMSContent('my-profile/user-agreement-priv-policy')
        .then(content => this.modalContent = content)
        .finally(() => this.loading = false);
	}
	
	public onContinueClick = () => {
		if (this.agreeChecked) {
			this.sending = true;
			this.contentService.saveAgreementPrivacyCompliance()
			.then(r => {
				if (r === true) {
					this.slatwall.account.acceptedAgreementFlag = true;
					this.close();
				} else {
					this.davisAlertService.error("Could not save response, please try again or contact us for assistance.");
				}
			})
			.finally(() => this.sending = false);
		} else {
			this.davisAlertService.error("Acceptance of Agreement and Privacy Policy is required to continue.");
		}
	}
}
    

class AgreementPrivacyModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
 		close:'=',
 		slatwall: '='
	};

	public controller = AgreementPrivacyModalController;
	public controllerAs = 'agreementPrivacyModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/agreement-privacy-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { AgreementPrivacyModal };
